import React from 'react';
import Economy from '../components/sections/Economy';

const EconomyPage = () => {
    return (
        <div style={{ paddingTop: '60px' }}>
            <Economy />
        </div>
    );
};

export default EconomyPage;
